import React from "react";
import Toolbar from "./Toolbar";

export const ControlToolbar = (props) => {
    return (
        <div style={{ flex: 1, flexGrow: 0 }}>
            <Toolbar viewMode={props.view_mode}>
                <div style={{ display: "inline-block", marginRight: "20px" }}>
                    { props.controls }  
                </div>
                {props.progressBar ? <div style={{ flex: 1, width: "100%" }}>{props.progressBar}</div> : null}
            </Toolbar>
        </div>
    );
};
